import { Box, Flex, Text, Switch } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";

function CollapseSwitch({
  open,
  onChange,
  title,
  children,
}: {
  open: boolean;
  onChange: (v: boolean) => void;
  title: string;
  children?: any;
}) {
  return (
    <>
      <Box
        p="16px"
        border="1px solid #ccc"
        borderRadius={8}
        borderColor={open ? colors.primary : colors.borderGray}
      >
        <Flex gap="8px">
          <Switch
            isChecked={!!open}
            onChange={() => {
              onChange(open ? false : true);
            }}
          />
          <Text>{title}</Text>
        </Flex>

        {children}
      </Box>
    </>
  );
}

export default CollapseSwitch;
